export default "__VITE_ASSET__Bkwwi1f4__"